module.exports = __webpack_public_path__ + "img/人才建设 手机端.065f25ec.jpg";